export const parseQuestionsAndAnswers = (data: Array<any>) => {
  return data.map((item: any) => {
    const {title, alternative_text} = item
    return {
      "question": title,
      "answer": alternative_text
    }
  })
};